module.exports = __webpack_public_path__ + "static/media/card-popup-icon.8076ab24.svg";